import React from 'react';
import { Box, Paper, Button, Divider, makeStyles }  from '@material-ui/core';
import { createFinalMessage } from '../../helpers';
import './end-game.css';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  message: {
    margin: '40px 0',
    padding: '40px 20px',
    fontSize: '1.2rem',
  },
  aboveDivider: {
    paddingBottom: '20px',
  },
  underDivider: {
    paddingTop: '20px',
  } 
}));

const EndGameMessage = ({ score, handleClickRestartGameBtn }) => {
  const classes = useStyles();

  return (
    <Paper className='end-game'>
      <Box className={classes.message}>
        <Box className={classes.aboveDivider}>Your score is {score} points out of 30.</Box>
        <Divider />
        <Box className={classes.underDivider}>{createFinalMessage(score)}</Box>
      </Box>
      <Button variant="outlined" color="primary" className='btn' onClick={() => handleClickRestartGameBtn()}>
        Restart Game
      </Button>
    </Paper>
  );
};

export default EndGameMessage;
